<template>
<div>
	<form @submit.prevent="validateBeforeSubmit">
		<div class="form-group row">
			<label for="inputPassword" class="col-sm-2 col-form-label col-form-label-sm">*Nome:</label>
			<div class="col-sm-10">
				<input type="text"
						name="descricao"
						v-validate="'required'"
						:class="{'is-invalid' : errors.has('descricao')}"
						v-model="form.descricao"
						class="form-control form-control-sm">
				<span  class="invalid-feedback" v-show="errors.has('descricao')">{{ errors.first('descricao') }}</span>
			</div>
		</div>

		<hr />


		<div class="row">
			<div class="col-6 animated fadeIn">
				<h5>Modulos:</h5>
				<div v-for="(priv, index) in privs" :key="index">
					<div class="privilegio-item" style="margin-bottom: 0.2em; border-radius: 0.4em;" :class="{'bg-dark text-white': priv._exibir }">
						<div class="row">
							<div class="col-12"  style="cursor:pointer; padding-left:2em" @click.prevent="privs.map(item => { item._exibir = false; return item }); priv._exibir = !priv._exibir; $forceUpdate()">
								<!-- <fa-icon class="float-right" icon="arrow-right" v-show="!priv._exibir" /> -->
								<fa-icon class="float-right" style="font-size: 1.8em" icon="arrow-right" v-show="priv._exibir" />
								{{priv.descricao}}
							</div>
						</div>
					</div>
				</div>

			</div>

			<div class="col-6">
				<h5>Privilégios:</h5>
				<div v-for="(priv, index) in privs" :key="index">
					<div>
						<div class="privilegio-item animated fadeIn" style="margin-bottom: 1em; border-radius: 0.4em;" :class="{'bg-success text-white': temPrivilegio(p) }" v-show="priv._exibir && p.acessoModulo" v-for="(p, idx) in priv.privilegios" :key="idx + 'i'">
							<div class="row">
								<div class="col-sm-12" style="cursor:pointer; padding-left:1.4em" :title="p.id" @click.prevent="setaPriv(p)">
									<fa-icon icon="check-circle" v-if="temPrivilegio(p)" />
									<fa-icon :icon="['far', 'circle']" v-else />
									{{p.descricao}}
								</div>
							</div>
						</div>

						<div class="privilegio-item animated fadeIn" style="margin-top:0.2em; border-radius: 0.4em; padding-left:1em" :class="{'bg-success text-white': temPrivilegio(p) }" v-show="priv._exibir && !p.acessoModulo && verificaSeTemAcesso(priv)" v-for="(p, idx) in priv.privilegios" :key="idx">
							<a href="#" :title="p.id" @click.prevent="setaPriv(p)">
								<div class="row">
									<div class="col-sm-12">
										<fa-icon icon="check-circle" v-if="temPrivilegio(p)" />
										<fa-icon :icon="['far', 'circle']" v-else/>
										{{p.descricao}}
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<hr/>

		<div class="row">
			<div class="col-sm-12 text-right">
				<small class="float-left text-info"><fa-icon icon="info-circle" transform="left-3" />Campos com * são obrigatórios.</small>
				<button class="btn btn-success btn-sm">
					<fa-icon icon="check" transform="left-3" /> SALVAR
				</button>
			</div>
		</div>
	</form>
</div>
</template>

<script>
import _ from 'lodash'
import axios from '../../../routers/axios'
export default {

    data(){
        return {
            editar: false,
            form: {
                id: 0,
				descricao: "",
				privilegio: [],
            },

			privs: [],
        }
    },

    mounted () {
    },

    methods: {

		setaPriv(priv){

			let index = _.findIndex(this.form.privilegio, o => { return o.id == priv.id})

			if(index == -1){
				this.form.privilegio.push(priv)
			} else {
				this.form.privilegio.splice(index, 1)

				// remove todos os privilegios daquele modulo
				if(priv.acessoModulo && priv.idModuloSistema != 1){

					var ids = []
					this.form.privilegio = this.form.privilegio.map(item => {

						if(item.idModuloSistema == priv.idModuloSistema){
							ids.push(item)
						}

						return item
					})

					if(ids.length > 0){
						for(var i in ids){
							let idx = _.findIndex(this.form.privilegio, o => {return o.id == ids[i].id})
							this.form.privilegio.splice(idx, 1)
						}
					}

				}
			}

			this.$forceUpdate()
		},

		verificaSeTemAcesso(modulo){

			for(var i in this.form.privilegio){
				if((this.form.privilegio[i].idModuloSistema == modulo.id && this.form.privilegio[i].acessoModulo) || modulo.descricao == 'GERAL'){
					return true
				}
			}

			return false
		},

		temPrivilegio(priv){

			for(var i in this.form.privilegio){
				if(this.form.privilegio[i].id == priv.id){
					return true
				}
			}

			return false
		},

        carregaDados (privs, item) {
			this.privs = privs.map(item => {
				item._exibir = false
				return item
			})

			if(item != null){
				this.editar = true
				this.form.id = item.id
				this.form.descricao = item.descricao
				this.form.privilegio = item.privilegio
			}

        },

        validateBeforeSubmit() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.salva();
                }
            });
        },

        salva(){

            var data = {
                id: this.form.id,
				descricao: this.form.descricao,
				privilegio: this.form.privilegio
            }

            this.$notify.loadIn('Salvando')

            if(this.editar){

                axios.put(this._getUrl(`api/perfil/${this.form.id}`), data).then(response => {
                    this.$emit('item-salvo', response.data)
                })

            } else {

                axios.post(this._getUrl('api/perfil'), data).then(response => {
                    this.editar = true
                    this.$emit('item-salvo', response.data)
                })
            }
        }
    }
}
</script>

<style>
.ir {
	position: absolute;
    right: 20px;
    top: 4px;
}

.privilegio-item {
	font-size: 0.9em;
	padding:0.5rem;
	border: 1px solid #CCC;
	margin-bottom:-1px;
}
</style>



// WEBPACK FOOTER //
// src/views/adm/perfil/cadastro.vue